module.exports = __webpack_public_path__ + "c05d34f737c0b5517ff28b8e5a065862.svg";